import { Box, TextField, Tooltip, IconButton, Button, LinearProgress } from '@mui/material'
import { Refresh as RefreshIcon, Add as AddIcon, Tag as TagIcon } from '@mui/icons-material'
import { useClassificationTask } from '../../../shared/context/classificationTaskContext'
import { useUtiles } from '../../../shared/context/utilesContext'
import { CreateClassificationComponent } from './CreateClassificationComponent'
import { useEffect } from 'react'
import { useTaskContext } from '../../../shared/context/taskContext'
export default function ClassificationComponent({ number, functionSelect=null }) {

    const { classificationTasks, loadingClassificationTasks, getClassificationTasks } = useClassificationTask()
    const { toogleOpenSilder, saveCurrentComponent, openSilderWith,restorePreviousComponent } = useUtiles()

    const { setTask } = useTaskContext()

    const handleSearch = (e) => {
        getClassificationTasks({ value: e.target.value, number })
    } 

    const handleCreateClassification = () => {
        saveCurrentComponent()
        openSilderWith(
            <CreateClassificationComponent number={number} />,
            500,
            'Crear Nueva Clasificación'
        )
    }

    const handleSelectClassification = (classification) => {
        const name = number === 1 ? 'classification_1' : 'classification_2'
        if (functionSelect) {
            functionSelect(classification, name)
            restorePreviousComponent()
        } else {
            setTask(prev => ({ ...prev, [name]: classification }))
            toogleOpenSilder(null, 500, null)
        }
    }

    useEffect(() => {
        getClassificationTasks({ number })
    }, [number])

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getClassificationTasks({ number })}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Button
                size="small"
                variant="contained"
                color="primary"
                sx={{ mt: 1 }}
                startIcon={<AddIcon />}
                onClick={handleCreateClassification}
            >
                Crear Clasificación
            </Button>
            { loadingClassificationTasks && <LinearProgress sx={{ mt: 2 }} />}
            <Box sx={{ mt: 2, maxHeight: '70vh', overflow: 'auto' }}>
                {classificationTasks.map((classification) => (
                    <Box 
                        key={classification.id}
                        onClick={() => handleSelectClassification(classification)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1.5,
                            mb: 1,
                            borderRadius: 1,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                            bgcolor: 'background.paper',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
                                transform: 'translateY(-2px)'
                            },
                            cursor: 'pointer'
                        }}
                    >
                        <Box sx={{ 
                            mr: 2, 
                            color: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TagIcon sx={{ fontSize: 20 }} />
                        </Box>
                        <Box sx={{ fontWeight: 500 }}>
                            {classification.value}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}